<template>
  <div class="wrokGroup-wrap page-margin">
    <div class="flex-row flex-auto" style="overflow: hidden">
      <!-- 工作组左侧树 -->
      <div class="section-mian_left">
        <div class="area-title">工作组</div>
        <div class="area-search">
          <el-input v-model="searchString" clearable :placeholder="$t('area.placeholder.name')">
          </el-input>
        </div>
        <el-scrollbar class="flex-auto" style="overflow: hidden">
          <el-tree v-if="showTree" ref="tree" class="tree-content" :data="treeData" :expand-on-click-node="false"
            node-key="id" :default-expanded-keys="expandedKeys" render-after-expand :load="asyncLoadNode" :lazy="lazyLoad"
            :props="treeProps" :highlight-current="true" :filter-node-method="filterNode" @node-click="nodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="label">{{ node.label }}</span>
              <span class="btn" style="margin-right: 5px" v-if="workGroupCode === data.id">
                <div class="area-operator" @click="addClick">
                  <el-button v-if="data.isDefault === '0'" type="text" v-auth="'/workGroup/index:add'" class="el-icon-plus"
                    size="mini" @click="() => appendArea(data)"></el-button>
                  <el-button v-if="data.isDefault === '0'" type="text" class="el-icon-edit-outline"
                    v-auth="'/workGroup/index:update'" size="mini" @click="() => editArea(node, data)"></el-button>
                  <el-button v-if="data.parentCode !== '-1' && data.isDefault === '0'" type="text"
                    class="el-icon-delete-solid" v-auth="'/workGroup/index:delete'" size="mini"
                    @click="() => removeArea(node, data)"></el-button>
                  <!-- <el-button
                    type="text"
                    icon="iconfont icon-zhanghushezhi"
                    size="mini"
                    @click="() => setPermissions(node, data)"
                  ></el-button> -->
                </div>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <ioc-table ref="crud" :data="tableData" :option="tableOption" :page="page" @size-change="changeSize"
          @current-change="currentChange" @selection-change="handleSelectionChange" @search-change="searchList"
          @search-reset="resetQuery">
          <!-- menuLeft -->
          <!-- <template slot="menuLeft">
            <div>
              <el-button
                type="primary"
                class="iss-operation-button"
                icon="el-icon-plus"
                @click="addSecurityStaff"
              >
                新增
              </el-button>
              <el-button
                type="primary"
                class="iss-operation-button"
                icon="el-icon-delete"
                @click="deleteSecurity"
              >
                批量删除
              </el-button>
            </div>
          </template> -->
          <template slot="img" slot-scope="scope">
            <img :src="getImgPath(scope.row.fileCode)" @click="showViewer(getImgPath(scope.row.fileCode), $event)"
              onerror="this.src='/images/theme/newDark/default.png'" style="height: 25px; width: 50px" />
          </template>
          <!-- <template slot="menu" slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
              <el-button type="text" icon="iconfont icon-shanchu" @click="handleDel(scope.row, scope.index)"></el-button>
            </el-tooltip>
          </template> -->
        </ioc-table>
      </div>
    </div>

    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <!-- 新增保卫工作组弹窗 -->
    <add-security ref="securityForm" :state="state" :treeInfo="clickTreeInfo" @refresh="refreshPage"></add-security>
    <!-- 新增人员 -->
    <!-- <person-transfer
      ref="transfer"
      :workGroupCode="workGroupCode"
      @refreshData="refresh"
    ></person-transfer> -->
    <appPanel :width="800" class="app-panel" :isExpand="showPersonPanel" title="新增成员" @cancel="handleClosePersonPanel">
      <personTransferNew ref="refPersonTrans"></personTransferNew>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePersonPanel" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSavePerson">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
    <!-- 权限设置穿梭框 -->
    <!-- <permission-group-transfer
      ref="refGroupTrans"
      @refreshData="refresh"
    ></permission-group-transfer> -->

    <appPanel :width="800" class="app-panel" :isExpand="showAuthPanel" title="配置工作组权限" @cancel="handleClosePanel">
      <groupTransferNew ref="refGroupTrans"></groupTransferNew>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSave">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
  </div>
</template>
<script>
// 工具库
import utils from "$utils";
import { Bus } from "$utils";
import appPanel from "@src/components/business/app-panel/index";
import tableOption from "../options/table";
import accountOption from "../options/accountOptions";
import { api } from "../api";
import addSecurity from "../components/addSecurity";
import personTransferNew from "../components/person-transferNew.vue";
// import personTransfer from "../components/person-transfer";
import groupTransferNew from "../components/permission-group-transferNew.vue";
// import permissionGroupTransfer from "../components/permission-group-transfer.vue";
export default {
  name: "perimeter",
  components: {
    addSecurity,
    // personTransfer,
    personTransferNew,
    // permissionGroupTransfer,
    appPanel,
    groupTransferNew,
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      showAuthPanel: false,
      showPersonPanel: false,
      viewerInstance: null,
      viewerPhotos: [],
      tableOption: tableOption(true, true),
      tableData: [],
      page: {
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        pageNum: 1,
        total: 0,
      },
      searchParams: {},
      state: 1, // 1: 新增 2：修改
      workGroupCode: "", //工作组code
      staffDialog: false,
      securityData: [],
      accountOption: accountOption(),
      securitytPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      securitytSearch: {},
      securityList: [],
      treeData: Object.freeze([]),
      // 展开的节点id
      expandedKeys: [],
      // 缓存全量树结构
      cacheTree: [],
      showTree: true,
      lazyLoad: false,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      searchString: "",
      // 根节点code
      rootCode: "",
      // 传递给弹框的信息
      clickTreeInfo: {},
      accountList: [],
      transferList: [],
      accountChecked: [],
      propStep: {
        label: "nickName",
        key: "accountNumber",
      },
      deleteSecurityList: [],
      subLoading: false,
    };
  },
  created() {
    this.accountOption.selection = true;
  },
  mounted() {
    this.getWorkGroupTree();
  },
  methods: {
    handleSavePerson() {
      let chooseIds = [];
      let selectArray = this.$refs.refPersonTrans.selectedList;
      if (selectArray.length) {
        selectArray
          .filter((item) => item.checked === true)
          .forEach((item) => {
            chooseIds.push(item.code);
          });
      }
      this.subLoading = true;
      let params = {
        accountNumberList: chooseIds,
        securityWorkGroupCode: this.$refs.refPersonTrans.SecurityWorkGroupId,
      };
      this.$fetch(api.addSecurityInfo, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("新增人员成功");
          this.handleClosePersonPanel();
          this.getList();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleSave() {
      let chooseIds = [];
      let selectArray = this.$refs.refGroupTrans.selectedList;
      if (selectArray.length) {
        selectArray
          .filter((item) => item.checked === true)
          .forEach((item) => {
            chooseIds.push(item.code);
          });
      }
      this.subLoading = true;
      let params = {
        authGroupCodeList: chooseIds,
        securityWorkGroupCode: this.$refs.refGroupTrans.SecurityWorkGroupId,
      };
      this.$fetch(api.updateSecurityWorkGroupAuthGroup, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("配置成功");
          this.handleClosePanel();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleClosePanel() {
      this.subLoading = false;
      this.showAuthPanel = false;
    },
    handleClosePersonPanel() {
      this.subLoading = false;
      this.showPersonPanel = false;
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    getAccountList() {
      const param = {
        accountType: 1,
      };
      this.$fetch(api.queryAccouts, param).then((response) => {
        if (response.success) {
          this.transferList = response.returnObj;
        }
      });
    },
    changeData(data) {
      this.accountChecked = data;
    },
    //获取工作组树列表
    getWorkGroupTree() {
      const self = this;
      this.$fetch(api.querySecurityWorkGroup, {}).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        self.cacheTree = result;
        self.treeData = Object.freeze(result);
        self.rootCode = self.treeData[0].id;
        self.workGroupCode = self.rootCode;
        self.expandedKeys = [self.treeData[0].id];
        // 默认高亮根节点
        this.$nextTick(function () {
          this.$refs.tree.setCurrentKey(self.rootCode);
          this.getList(self.workGroupCode);
        });
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.securityWorkGroupCode;
          entity.name = item.securityWorkGroupName;
          entity.appointmentCarNotifyFlag = item.appointmentCarNotifyFlag;
          entity.appointmentNoCarNotifyFlag = item.appointmentNoCarNotifyFlag;
          entity.leaderCode = item.securityWorkGroupLeader;
          entity.leaderName = item.leaderName;
          entity.parentCode = item.parentCode;
          entity.areaDevGroupCodeList = item.areaDevGroupCodeList;
          entity.isLeaf = !item.hasLeaf || !item.securityWorkGroupChildren;
          entity.isDefault = item.isDefault || '0';
          if (item.securityWorkGroupChildren) {
            entity.children = self.menusDataPro(item.securityWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    showOwnerList(list) {
      return list.map((item) => item.personnelName).join(",");
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    // 单击节点时
    nodeClick(data) {
      console.log(data)
      this.workGroupCode = data.id;
      this.getList(this.workGroupCode);
    },
    addClick(event) {
      event.stopPropagation();
    },
    appendArea(evt) {
      this.state = 1;
      this.clickTreeInfo = evt;
      this.$refs.securityForm.open();
    },
    removeArea(node, data) {
      let idsArr = [];
      idsArr.push(data.id);
      if (data.children && data.children.length !== 0) {
        data.children.forEach((item) => {
          idsArr.push(item.id);
        });
      }
      this.$confirm("您确定删除该工作组及下属工作组么?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          securityWorkGroupCodes: idsArr,
        };
        // console.log('---删除ids----', params);
        this.$fetch(api.deleteSecurityWorkGroup, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success("删除成功");
            this.refreshPage();
          }
        });
      });
    },
    editArea(node, data) {
      this.clickTreeInfo = data;
      this.state = 2;
      this.$nextTick(() => {
        this.$refs.securityForm.open();
      });
    },
    // 设置权限
    setPermissions(node, data) {
      this.showAuthPanel = true;
      this.$nextTick(() => {
        this.$refs.refGroupTrans.open(data.id);
      });
    },

    refreshPage() {
      this.getWorkGroupTree();
      // this.getList(this.workGroupCode);
    },
    refresh() {
      this.getList(this.workGroupCode);
    },

    // 人员新增按钮
    addSecurityStaff() {
      // this.$refs.transfer.open();
      this.showPersonPanel = true;
      this.$nextTick(() => {
        this.$refs.refPersonTrans.open(this.workGroupCode);
      });
    },
    handleDel(item) {
      this.deleteSecurityList = [
        {
          accountNumber: item.accountNumber,
          securityWorkGroupCode: item.securityWorkGroupCode,
        },
      ];
      this.deleteSecurity();
    },
    // 人员删除按钮
    deleteSecurity() {
      if (this.deleteSecurityList.length === 0) {
        this.$message.warning("请选择需要删除的人员");
      } else {
        this.$confirm("您确定删除选中的人员么?", "删除确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$fetch(api.deleteSecurityInfo, this.deleteSecurityList).then(
            (res) => {
              if (res.success) {
                this.$message.success("删除人员成功");
                // this.refreshPage();
                this.getList();
              } else {
                this.$message.error(res.msgContent);
              }
            }
          );
        });
      }
    },
    handleSelectionChange(data) {
      this.deleteSecurityList = data.map((item) => {
        return {
          accountNumber: item.accountNumber,
          securityWorkGroupCode: item.securityWorkGroupCode,
        };
      });
    },
    getList() {
      const params = {};
      params.nickName = this.searchParams.nickName;
      params.securityWorkGroupCode = this.workGroupCode;
      params.phone = this.searchParams.phone;
      params.pageNum = this.page.pageNum;
      params.pageSize = this.page.pageSize;
      this.$fetch(api.getSecurityInfoList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj.total;
        // console.log(this.page);
        this.$refs.crud.selectClear();
      });
    },
    // 重置按钮
    resetQuery() {
      this.getList(this.workGroupCode);
    },
    searchList(param) {
      this.searchParams = Object.assign(param);
      this.getList(this.workGroupCode);
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    // 点击上一页下一页按钮
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.wrokGroup-wrap {
  width: 100%;
  height: calc(100% - 12px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 12px!important;

  .ioc-table {
    padding-top: 0;
  }

  .section-mian_left {
    margin-right: 8px !important;
    display: flex;
    flex-direction: column;
    width: 380px;

    .area-title {
      margin: 16px 0 10px 10px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
      font-size: 14px;
    }

    .area-search {
      display: flex;
      margin: 10px;
      height: 28px;

      .el-input {
        width: 100%;
      }
    }

    .tree-content {
      width: fit-content;
      min-width: 100%;

      .el-tree-node__label {
        display: inline-block;
        max-width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      :deep .el-tree-node__content {
        height: 40px;
        line-height: 40px;

        .custom-tree-node {
          display: flex;
          justify-content: space-between;
          width: 100%;

          // height: 35px;
          // line-height: 35px;
          span {
            display: inline-block;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .label {
            width: 200px;
          }

          .area-operator {
            display: inline-block;
            margin-left: 5px;

            .el-button {
              // color: #fff !important;
            }
          }
        }

        &:before {
          margin-top: -26px !important;
        }
      }
    }
  }

  .el-transfer-panel {
    @include set_theme_color(background-color, page-bg-color);

    &__header {
      @include set_theme_color(background-color, blur-color);
    }

    .el-checkbox__label {
      color: #fff !important;
    }
  }
}
</style>
